import React, { useEffect, useState } from "react";
import { useAdminApi } from "./adminApi";
import AdminPanelProductsDetails from "./AdminPanelProductsDetails";
import classNames from "classnames";

export default function AdminPanelProducts() {
  const api = useAdminApi();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Получаем список товаров и категорий
  useEffect(() => {
    api.get("admin/products/").then(({ data, status }) => {
      if (status === 200 && Array.isArray(data)) setProducts(data);
      else setProducts([]);
    });
    api.get("admin/categories/").then(({ data, status }) => {
      if (status === 200 && Array.isArray(data)) setCategories(data);
      else setCategories([]);
    });
  }, []);

  // Поддержка подкатегорий (если нужны)
  const getChildrenCategories = (parentId) =>
    categories.filter((cat) => String(cat.parent_id) === String(parentId));

  // Товары по id категории (parentId === null => корневые категории)
  const productsForCategory = (catId) =>
    products.filter(
      (p) =>
        String(p.category) === String(catId) ||
        (typeof p.category === "object" && String(p.category?.id) === String(catId))
    );

  // Рекурсивный вывод категорий и подкатегорий
  const renderCategory = (cat) => (
    <div key={cat.id} className="border rounded shadow-sm bg-white mb-1">
      <button
        className={classNames(
          "w-full flex justify-between items-center p-3 cursor-pointer hover:bg-gray-100 transition",
          expandedCategories.includes(cat.id) && "bg-gray-50"
        )}
        onClick={() =>
          setExpandedCategories((prev) =>
            prev.includes(cat.id)
              ? prev.filter((id) => id !== cat.id)
              : [...prev, cat.id]
          )
        }
      >
        <span className="font-bold text-lg">{cat.name}</span>
        <span>{expandedCategories.includes(cat.id) ? "▲" : "▼"}</span>
      </button>
      {expandedCategories.includes(cat.id) && (
        <div>
          <ul className="divide-y">
            {productsForCategory(cat.id).length > 0 ? (
              productsForCategory(cat.id).map((product) => (
                <li
                  key={product.id}
                  className="flex items-center py-2 px-4 hover:bg-gray-50 cursor-pointer"
                  onClick={() => setSelectedProduct(product)}
                >
                  <img
                    src={
                      product.image
                        ? product.image.startsWith("http")
                          ? product.image
                          : `/media/${product.image}`
                        : "/no-image.png"
                    }
                    alt={product.name}
                    className="w-12 h-12 object-contain rounded mr-4 border"
                  />
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold truncate">{product.name}</div>
                    <div className="text-sm text-gray-500 truncate">
                      Остаток: <b>{product.quantity ?? "?"}</b>
                    </div>
                  </div>
                  <div className="ml-4 font-bold whitespace-nowrap">{product.price} ₽</div>
                </li>
              ))
            ) : (
              <li className="py-2 px-4 text-gray-400">Нет товаров в категории</li>
            )}
          </ul>
          {/* Рекурсивно выводим подкатегории */}
          {getChildrenCategories(cat.id).length > 0 && (
            <div className="ml-4">
              {getChildrenCategories(cat.id).map(renderCategory)}
            </div>
          )}
        </div>
      )}
    </div>
  );

  return (
    <section>
      <h2 className="text-xl font-semibold mb-4">Категории и товары</h2>
      <div className="space-y-2">
        {categories && categories.length > 0 ? (
          // Выводим только root категории (parent_id == null)
          categories
            .filter((cat) => cat.parent_id == null)
            .map(renderCategory)
        ) : (
          <div className="py-8 text-center text-gray-400">Нет категорий</div>
        )}
      </div>
      {/* Модалка деталей */}
      {selectedProduct && (
        <AdminPanelProductsDetails
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
        />
      )}
    </section>
  );
}
